module.exports = __webpack_public_path__ + "static/media/bonecoMaisPequeno.d5ce1a21.svg";